export const mapDirectTaxEntry = (
  directEntry,
  {
    period,
    taxYear,
    companyCode,
    countryTaxType,
    currencyToDisplay,
    bookType,
    entryType,
    activity,
    grossFlag,
  }
) => ({
  periodName: period,
  companyCode,
  taxYear,
  countryTaxType,
  entryType,
  entryActivity: activity,
  comment: directEntry.comment,
  [grossFlag ? 'grossAmount' : 'netAmount']: directEntry.amount,
  currency: currencyToDisplay,
  topsideFlag: directEntry.topsideFlag,
  fbosFlag: directEntry.fbosFlag,
  bookType,

  transferFlag: directEntry.transfer,

  account: directEntry.taxEntryAccountId,
  glAccountOverride: directEntry.glAccountOverride,
  fromAccount: directEntry.fromTaxEntryAccountId,

  files: directEntry.files,
  grossFlag,
});

export const findDirectTaxEntriesDelta = (
  rows,
  {
    slGroupItem,
    periodFrom,
    taxYear,
    countryTaxType,
    currencyToDisplay,
    bookType,
    grossFlag,
  }
) => rows.reduce((acc, row) => {
  const rowDelta = Object.values(row).reduce((rowAcc, cell) => {
    if (!cell.edited) {
      return rowAcc;
    }

    return rowAcc.concat(mapDirectTaxEntry(cell, {
      companyCode: slGroupItem.value,
      period: periodFrom.name,
      taxYear: taxYear.value,
      countryTaxType: countryTaxType.value,
      currencyToDisplay,
      bookType,
      entryType: row.entryType,
      activity: cell.activity,
      grossFlag,
    }));
  }, []);

  if (!rowDelta.length) {
    return acc;
  }

  return acc.concat(rowDelta);
}, []);

export const findDirectTaxEntriesDeltaFroGrouppedReport = (
  rows,
  {
    slGroupItem,
    periodFrom,
    countryTaxType,
    currencyToDisplay,
    bookType,
  }
) => rows.reduce((acc, row) => {
  const rowDelta = Object.values(row).reduce((rowAcc, cell) => {
    if (!cell.edited) {
      return rowAcc;
    }

    return rowAcc.concat(mapDirectTaxEntry(cell, {
      companyCode: slGroupItem.value,
      period: periodFrom.name,
      taxYear: row.taxYearForEditableChecks,
      countryTaxType: countryTaxType.value,
      currencyToDisplay,
      bookType,
      entryType: row.entryType,
      activity: cell.activity,
    }));
  }, []);

  if (!rowDelta.length) {
    return acc;
  }

  return acc.concat(rowDelta);
}, []);
